import { createSelectionListViewComponent } from 'factories/SelectionListView'
import { getSessionItem, updateSessionItem } from 'helpers/sessionStorage'
import { getStorageKey } from '.'

export default createSelectionListViewComponent({
  pageTitleLanguageKey: 'day',
  getItemSize: () => 45,
  allowSearch: () => false,
  getValue: () => getSessionItem(getStorageKey(), {}).item?.recurOnDaysOfMonth,
  getOnChange: (self) => (each) => {
    updateSessionItem(getStorageKey(), {}, (draft) => {
      draft.item.recurOnDaysOfMonth = [each.id]
    })
  },
})()
